import { render, staticRenderFns } from "./report-description.vue?vue&type=template&id=761c47c7&scoped=true&"
import script from "./report-description.vue?vue&type=script&lang=js&"
export * from "./report-description.vue?vue&type=script&lang=js&"
import style0 from "./report-description.vue?vue&type=style&index=0&id=761c47c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761c47c7",
  null
  
)

export default component.exports